<div class="form-panel__body" [formGroup]="form">

  <!-- ── Your question ───────────────────────────────────────────────── -->
  <div class="query-section" [class.query-section--collapsed]="!sectionOpen.question">
    <div class="query-section__header" (click)="toggleSection('question')">
      <div class="query-section__header-main">
        <app-section-icon class="query-section__icon" name="question"></app-section-icon>
        <div class="query-section__header-text">
          <span class="query-section__title">Your question</span>
          <span class="query-section__desc">What you're asking</span>
        </div>
      </div>
      <span class="query-section__toggle">
        <svg class="query-section__chevron" width="14" height="14" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <path d="M2.5 4.5L6 8L9.5 4.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </span>
    </div>
    <div class="query-section__body" [style.display]="sectionOpen.question ? 'flex' : 'none'">


      <div class="form-field">
        <label class="form-field__label">Question<span class="form-field__required">*</span></label>
        <textarea class="field-textarea" formControlName="question" placeholder="What are the key announcements of Skanska for last 6 months"></textarea>
        <div class="question-row">
          <!-- Shared by the dropdown below and, on phones, the help sheet. -->
          <ng-template #helpRows>
            <div class="operators-help__row">
              <span class="operators-help__badge operators-help__badge--syntax">1</span>
              <div class="operators-help__text">
                <p>For questions requiring comprehensive results, ask only one question at a time.</p>
              </div>
            </div>
            <div class="operators-help__row">
              <span class="operators-help__badge operators-help__badge--syntax">2</span>
              <div class="operators-help__text">
                <p>Phrase the question in natural language, without Boolean operators, and use correct grammar whenever possible.</p>
              </div>
            </div>
            <div class="operators-help__row">
              <span class="operators-help__badge operators-help__badge--syntax">3</span>
              <div class="operators-help__text">
                <p>English is recommended for best results.</p>
              </div>
            </div>
            <div class="operators-help__row">
              <span class="operators-help__badge operators-help__badge--syntax">4</span>
              <div class="operators-help__text">
                <p>Keep the question atomic, focusing on a single topic or fact.</p>
              </div>
            </div>
            <div class="operators-help__row">
              <span class="operators-help__badge operators-help__badge--syntax">5</span>
              <div class="operators-help__text">
                <p>While not required, it is recommended to enclose named entities in quotation marks.</p>
                <code>"Nestlé", "Ulf Kristersson"</code>
              </div>
            </div>
            <div class="operators-help__row">
              <span class="operators-help__badge operators-help__badge--syntax">6</span>
              <div class="operators-help__text">
                <p>To avoid compromising the quality of the results, do not include instructions on how the response should be generated or formatted.</p>
                <code>Present as a bulleted list</code>
              </div>
            </div>
          </ng-template>
          <div class="dropdown" (appClickOutside)="closeTips()">
            <button type="button" class="link question-tips__link" [attr.aria-expanded]="tipsOpen" (click)="toggleTips($event)">Tips for better results</button>
            @if (tipsOpen) {
              <div class="operators-help question-tips dropdown__menu dropdown__menu--left">
                <p class="operators-help__title">Tips for better results</p>
                <ng-container [ngTemplateOutlet]="helpRows" />
              </div>
            }
          </div>
        </div>
        <!-- Prompt Optimizer link disabled until the feature is complete
             restore this button (and its Answer counterpart) once it's ready. -->
        <!--
        <button type="button" class="link form-field__link" style="background:none;border:none;padding:0;font-family:inherit;text-align:left;" [disabled]="!form.value.question?.trim()" (click)="openPromptOptimizer()">Perfect your prompt with our Prompt Optimizer</button>
        -->
      </div>

    </div>
  </div>

  <!-- ── Request configuration ────────────────────────────────────────── -->
  <div class="query-section" [class.query-section--collapsed]="!sectionOpen.request">
    <div class="query-section__header" (click)="toggleSection('request')">
      <div class="query-section__header-main">
        <app-section-icon class="query-section__icon" name="request"></app-section-icon>
        <div class="query-section__header-text">
          <span class="query-section__title">Request configuration</span>
          <span class="query-section__desc">Define what to search for and where to look</span>
        </div>
      </div>
      <span class="query-section__toggle">
        <svg class="query-section__chevron" width="14" height="14" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <path d="M2.5 4.5L6 8L9.5 4.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </span>
    </div>
    <div class="query-section__body" [style.display]="sectionOpen.request ? 'flex' : 'none'">

      @if (isCikisiUser) {
      <div class="cikisi-block">
        <div class="form-section__toggle-row">
          <label class="cikisi__toggle">
            <input type="checkbox" class="cikisi__input" formControlName="cikisiOnly">
            <span class="toggle__track"><span class="toggle__thumb"></span></span>
          </label>
          <div class="form-section__toggle-info">
            <span class="form-sublabel">Search only Cikisi content</span>
            <div class="form-section__status">
              <span class="status-dot status-dot--green"></span>
              <span class="form-hint">Connected</span>
              <span class="form-hint">sk-cikisi-••••••••••••••••••4f2a</span>
            </div>
          </div>
        </div>

        <div class="filter-rows">
          <p class="filter-rows__label">Filter cikisi content by</p>

          <!-- Its own on/off row, a sibling of Knowledge Topics below
               rather than folded into it (see toggleKnowledgeBase()) no
               body of its own since there's nothing to pick, just whether
               the whole knowledge base is in scope. -->
          <div class="filter-row" [class.filter-row--on]="form.value.knowledgeBase">
            <div class="filter-row__header" (click)="toggleKnowledgeBase()">
              <span class="filter-row__check" [class.filter-row__check--on]="form.value.knowledgeBase"></span>
              <span class="filter-row__label">Knowledge Base</span>
            </div>
          </div>

          @for (rowCtrl of filterRowsArray.controls; track rowCtrl; let i = $index) {
            <div
              class="filter-row"
              [class.filter-row--on]="rowCtrl.value.expanded"
              [class.filter-row--disabled]="FILTER_ROW_META[i].id === 'p-kt' && form.value.knowledgeBase"
            >
              <div class="filter-row__header" (click)="onFilterRowHeaderClick(FILTER_ROW_META[i], rowCtrl)">
                <span class="filter-row__check" [class.filter-row__check--on]="rowCtrl.value.expanded"></span>
                <span class="filter-row__label">{{ FILTER_ROW_META[i].label }}</span>
                <span class="filter-row__count" [class.filter-row__count--inactive]="!rowCtrl.value.expanded">{{ rowChipCount(rowCtrl) > 0 ? rowChipCount(rowCtrl) + ' selected' + (!rowCtrl.value.expanded ? ' (not applied)' : '') : '' }}</span>
                <svg class="filter-row__chevron" viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M6 3.5 10.5 8 6 12.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
              </div>
              @if (FILTER_ROW_META[i].kind === 'flat') {
                <div class="filter-row__body" [style.display]="rowCtrl.value.expanded ? 'block' : 'none'">
                  <mila-multi-select
                    [formControl]="rowSelectControlOf(rowCtrl)"
                    [fetchPage]="flatFetchers[FILTER_ROW_META[i].id]"
                    [placeholder]="FILTER_ROW_META[i].placeholder"
                  ></mila-multi-select>
                </div>
              }
            </div>
          }
        </div>
      </div>
      }

      <div class="form-field form-field--narrow">
        <label class="form-sublabel">Published between</label>
        <div class="form-field__date-row">

          <div class="date-picker-wrap" (appClickOutside)="closeCal(calFrom)">
            <div class="field-input field-input--date" (click)="toggleCal(calFrom, $event, 'Published from')">
              <svg class="field-input__icon" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M5 1.5C5 1.22386 5.22386 1 5.5 1C5.77614 1 6 1.22386 6 1.5V2H10V1.5C10 1.22386 10.2239 1 10.5 1C10.7761 1 11 1.22386 11 1.5V2H12C12.5523 2 13 2.44772 13 3V13C13 13.5523 12.5523 14 12 14H4C3.44772 14 3 13.5523 3 13V3C3 2.44772 3.44772 2 4 2H5V1.5ZM4 5V13H12V5H4Z" fill="currentColor"/></svg>
              <span class="form-hint">{{ formatDate(calFrom) || 'From' }}</span>
              @if (calFrom.selected) {
                <button type="button" class="field-input__clear" aria-label="Clear date" (click)="clearDate(calFrom, $event)">
                  <svg viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M4.5 4.5l7 7M11.5 4.5l-7 7" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>
                </button>
              }
            </div>
            @if (calFrom.open) {
              <div class="cal-dropdown" (click)="$event.stopPropagation()">
                <div class="cal-header">
                  <button class="cal-nav" (click)="prevMonth(calFrom, $event)">&#8249;</button>
                  <span class="cal-month">{{ MONTH_NAMES[calFrom.month] }} {{ calFrom.year }}</span>
                  <button class="cal-nav" (click)="nextMonth(calFrom, $event)">&#8250;</button>
                </div>
                <div class="cal-grid">
                  @for (d of DAY_NAMES; track d) {
                    <div class="cal-dow">{{ d }}</div>
                  }
                  @for (day of calDays(calFrom); track $index) {
                    <div class="cal-day"
                         [class.cal-day--selected]="isSelected(calFrom, day)"
                         [class.cal-day--today]="isToday(calFrom, day)"
                         [class.cal-day--empty]="!day"
                         (click)="selectDay(calFrom, day, $event)">{{ day || '' }}</div>
                  }
                </div>
              </div>
            }
          </div>

          <div class="date-picker-wrap" (appClickOutside)="closeCal(calTo)">
            <div class="field-input field-input--date" (click)="toggleCal(calTo, $event, 'Published to')">
              <svg class="field-input__icon" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M5 1.5C5 1.22386 5.22386 1 5.5 1C5.77614 1 6 1.22386 6 1.5V2H10V1.5C10 1.22386 10.2239 1 10.5 1C10.7761 1 11 1.22386 11 1.5V2H12C12.5523 2 13 2.44772 13 3V13C13 13.5523 12.5523 14 12 14H4C3.44772 14 3 13.5523 3 13V3C3 2.44772 3.44772 2 4 2H5V1.5ZM4 5V13H12V5H4Z" fill="currentColor"/></svg>
              <span class="form-hint">{{ formatDate(calTo) || 'To' }}</span>
              @if (calTo.selected) {
                <button type="button" class="field-input__clear" aria-label="Clear date" (click)="clearDate(calTo, $event)">
                  <svg viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M4.5 4.5l7 7M11.5 4.5l-7 7" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>
                </button>
              }
            </div>
            @if (calTo.open) {
              <div class="cal-dropdown" (click)="$event.stopPropagation()">
                <div class="cal-header">
                  <button class="cal-nav" (click)="prevMonth(calTo, $event)">&#8249;</button>
                  <span class="cal-month">{{ MONTH_NAMES[calTo.month] }} {{ calTo.year }}</span>
                  <button class="cal-nav" (click)="nextMonth(calTo, $event)">&#8250;</button>
                </div>
                <div class="cal-grid">
                  @for (d of DAY_NAMES; track d) {
                    <div class="cal-dow">{{ d }}</div>
                  }
                  @for (day of calDays(calTo); track $index) {
                    <div class="cal-day"
                         [class.cal-day--selected]="isSelected(calTo, day)"
                         [class.cal-day--today]="isToday(calTo, day)"
                         [class.cal-day--empty]="!day"
                         (click)="selectDay(calTo, day, $event)">{{ day || '' }}</div>
                  }
                </div>
              </div>
            }
          </div>

        </div>
      </div>

      <div class="form-field">
        <label class="form-sublabel">Geolocated areas</label>
        @if (geolocatedAreasArray.length) {
          <div class="field-input field-input--tag">
            @for (chip of geolocatedAreasArray.controls; track $index; let i = $index) {
              <span class="chip">{{ chip.value.label }}&nbsp;<span class="chip__remove" (click)="removeDomainChip(geolocatedAreasArray, i)">×</span></span>
            }
          </div>
        }
        <button type="button" class="map-btn" (click)="openMapAreaPicker()">
          <svg class="map-btn__icon" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path fill-rule="evenodd" clip-rule="evenodd" d="M8 1C5.23858 1 3 3.23858 3 6C3 9.5 8 15 8 15C8 15 13 9.5 13 6C13 3.23858 10.7614 1 8 1ZM8 8C6.89543 8 6 7.10457 6 6C6 4.89543 6.89543 4 8 4C9.10457 4 10 4.89543 10 6C10 7.10457 9.10457 8 8 8Z" fill="currentColor"/></svg>
          <span>Open map to draw areas</span>
        </button>
      </div>

      <div class="form-field">
        <label class="form-sublabel">Include domains</label>
        <div class="field-input field-input--tag">
          @for (chip of includeChipsArray.controls; track $index; let i = $index) {
            <span class="chip">{{ chip.value }}&nbsp;<span class="chip__remove" (click)="removeDomainChip(includeChipsArray, i)">×</span></span>
          }
          <input type="text" class="filter-chip-input__field" placeholder="e.g. skanska.com" (keydown)="onDomainKey($event, includeChipsArray)">
        </div>
      </div>

      <div class="form-field">
        <label class="form-sublabel">Exclude domains</label>
        <div class="field-input field-input--tag">
          @for (chip of excludeChipsArray.controls; track $index; let i = $index) {
            <span class="chip">{{ chip.value }}&nbsp;<span class="chip__remove" (click)="removeDomainChip(excludeChipsArray, i)">×</span></span>
          }
          <input type="text" class="filter-chip-input__field" placeholder="e.g. google.com" (keydown)="onDomainKey($event, excludeChipsArray)">
        </div>
      </div>

      <div class="form-field">
        <label class="form-sublabel">Language search</label>
        <mila-multi-select
          formControlName="languageSearch"
          [fetchPage]="languageFetcher"
          sheetTitle="Languages"
          placeholder="Search languages…"
        ></mila-multi-select>
      </div>

      <label class="toggle">
        <input type="checkbox" class="toggle__input" formControlName="searchImageDescriptions">
        <span class="toggle__track"><span class="toggle__thumb"></span></span>
        <span class="toggle__label">Search in image descriptions</span>
      </label>

      <!-- Moved here from Response configuration: these shape how broadly
           the search itself runs (how many snippets are considered, how
           relevance is scored), which reads more like "what to search"
           than "what comes back" even though buildPayload() still sends
           them inside the wire request's own `response` envelope, since
           that's the real, documented API contract (see
           data/docs-api-data.ts's responseParams) and unrelated to which
           card a control is grouped under here. -->
      <div class="form-field">
        <label class="form-sublabel">Degree of control over the relevance of snippets</label>
        <p class="form-hint">Number of criteria that will be taken into consideration in calculations (terms, vectors, period, answer)</p>
        <div class="slider-row">
          <input type="range" class="range" min="1" max="5" formControlName="relevanceCriteriaCount" />
          <span class="form-hint">{{ form.value.relevanceCriteriaCount }} criteria</span>
        </div>
      </div>

      <label class="toggle">
        <input type="checkbox" class="toggle__input" formControlName="useSourcePopularity">
        <span class="toggle__track"><span class="toggle__thumb"></span></span>
        <span class="toggle__label">Take into account your source popularity score on cikisi</span>
      </label>

      <div class="form-field">
        <label class="form-sublabel">Comprehensiveness</label>
        <p class="form-hint">Number of snippets that will be processed and listed</p>
        <div class="slider-row">
          <input type="range" class="range" min="0" max="200" formControlName="comprehensiveness" />
          <span class="form-hint">{{ form.value.comprehensiveness }}</span>
        </div>
      </div>

    </div>
  </div>

  <!-- ── Response configuration collapsed by default: set once, rarely revisited ── -->
  <div class="query-section" [class.query-section--collapsed]="!sectionOpen.response">
    <div class="query-section__header" (click)="toggleSection('response')">
      <div class="query-section__header-main">
        <app-section-icon class="query-section__icon" name="response"></app-section-icon>
        <div class="query-section__header-text">
          <span class="query-section__title">Response configuration</span>
          <span class="query-section__desc">Control what comes back in the result</span>
        </div>
      </div>
      <span class="query-section__toggle">
        <svg class="query-section__chevron" width="14" height="14" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <path d="M2.5 4.5L6 8L9.5 4.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </span>
    </div>
    <div class="query-section__body" [style.display]="sectionOpen.response ? 'flex' : 'none'">

      <div class="form-field">
        <div class="form-field__info">
          <label class="form-sublabel">Output details</label>
          <p class="form-hint">In addition to the snippet<br>(English machine translated version, URL, and publication date):</p>
        </div>
        <div class="form-field__toggles">
          <label class="toggle"><input type="checkbox" class="toggle__input" formControlName="includeRelevanceScore"><span class="toggle__track"><span class="toggle__thumb"></span></span><span class="toggle__label">Relevance score of the snippet</span></label>
          <label class="toggle"><input type="checkbox" class="toggle__input" formControlName="includeOriginalLanguageSnippet"><span class="toggle__track"><span class="toggle__thumb"></span></span><span class="toggle__label">Snippet in its original language</span></label>
          <label class="toggle"><input type="checkbox" class="toggle__input" formControlName="includeArticleTitle"><span class="toggle__track"><span class="toggle__thumb"></span></span><span class="toggle__label">Title of the article from which the snippet is extracted</span></label>
          <label class="toggle"><input type="checkbox" class="toggle__input" formControlName="includeImageUrl"><span class="toggle__track"><span class="toggle__thumb"></span></span><span class="toggle__label">URL of the image in the article from which the snippet is extracted</span></label>
          <label class="toggle"><input type="checkbox" class="toggle__input" formControlName="includeDomainName"><span class="toggle__track"><span class="toggle__thumb"></span></span><span class="toggle__label">Domain name of the website from which the snippet is extracted</span></label>
          <label class="toggle"><input type="checkbox" class="toggle__input" formControlName="includeFavicon"><span class="toggle__track"><span class="toggle__thumb"></span></span><span class="toggle__label">Favicon of the website from which the snippet is extracted</span></label>
        </div>
      </div>

    </div>
  </div>

</div>
